export default "__VITE_ASSET__e1d3ab3c__"